import {JSX, useState, useEffect} from 'react';
import { format } from 'date-fns';
import WindowBar from '../../common/windowBar/windowBar';
import timeIcon from '../../assets/images/svgs/time.svg';
import './clcok.css';

export type TimeZones = [
    'America/New_York',
    'America/Los_Angeles',
    'America/Chicago',
    'Europe/London',
    'Europe/Paris',
    'Asia/Tokyo',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Australia/Sydney',
    'Pacific/Auckland'
];

interface ClockProps {
    timeZone?: string,
    smallerSize?: boolean,
}

const Clock = ({ timeZone, smallerSize }: ClockProps) : JSX.Element => {
    const [time, setTime] = useState(new Date());
    const [is24Hour, setIs24Hour] = useState(true);
    const [selectedTimezone, setSelectedTimezone] = useState(
        timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    const [title, setTitle] = useState('time');

    useEffect(() => {
        setTitle(formatTimezoneName(selectedTimezone));
    }, [selectedTimezone]);

    useEffect(() => {
        const timer = setInterval(() => {
        setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const getTimeComponents = (date) => {
        const options = {
          timeZone: selectedTimezone,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: !is24Hour
        };
    
        if (is24Hour) {
          const timeStr = date.toLocaleTimeString('en-US', options);
          return { time: timeStr, period: '' };
        }
    
        const timeStr = date.toLocaleTimeString('en-US', options);
        const [time, period] = timeStr.split(' ');
        return { time, period };
    };

    const formatTimezoneName = (tz: string) => {
        return (tz.split('/').pop() || tz).replace(/_/g, ' ');
    };

    const formatDate = (date: Date | null): string => {
        return date ? format(date, 'MMM dd, EEE') : 'No date set';
    };

    return(
        <div className='outter-container clock-container'>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='pixel-container-border'>
                    <WindowBar IconSrc={timeIcon} title={title} onClick={()=>{}}/>
                    <div className='main-pixel-container main-clock-container'>
                        <p className={`clock-text ${smallerSize? 'small' : ''}`}>{getTimeComponents(time).time}</p>
                        <p className={`clock-date-text ${smallerSize? 'small' : ''}`}>{formatDate(time)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Clock;